import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import { MenuContainer } from './styles';
import UserAvatar from 'components/Page/Toolbox/UserAvatar';
import SettingsIcon from 'components/Brand/Icons/Toolbox/SettingsIcon';
import LogoutIcon from 'components/Brand/Icons/Toolbox/LogoutIcon';
import Text from 'components/Core/Text';

const AccountMenu = ({ userInfo, onLogOut }) => {
  return (
    <MenuContainer>
      <div className="top">
        <div>
          <UserAvatar userInfo={userInfo} width="80" height="80" />
        </div>
        <Text type="p" size="normal" marginMobile="0 0 5px 0">
          {userInfo.displayName}
        </Text>
        <Text type="p" size="small" marginMobile="0">
          {userInfo.email}
        </Text>
      </div>
      <div>
        <div>
          <SettingsIcon width="24" height="24" />
        </div>
        <div>
          <HyperLink href="/toolbox/settings">
            <Text type="p" size="normal" marginMobile="2px 0 0 0">
              Manage Your Account
            </Text>
          </HyperLink>
        </div>
      </div>
      <div onClick={onLogOut}>
        <div>
          <LogoutIcon width="24" height="24" />
        </div>
        <Text type="p" size="normal" marginMobile="2px 0 0 0">
          Sign Out
        </Text>
      </div>
    </MenuContainer>
  );
};

export default AccountMenu;
